import { Component } from "react";
import Toolbar from "../components/toolbar";
import { MdAddBox } from "react-icons/md";
import { addDoc, collection, deleteDoc, getDocs, orderBy, query, updateDoc } from "firebase/firestore/lite";
import { dbPublic } from "../../App";
import { CgCloseO } from "react-icons/cg";


class Shows extends Component<any,any> {

    constructor(props:any)
    {
        super(props);
        this.state = {
            Pics: [],
        }
    }

    async downloadPics(files:FileList)
    {
        for(var i=0; i<files.length; i++)
        {

            var x = new FileReader();
            x.onload = async (a) => {
                var tCol = collection(dbPublic,'showpictures');
                await addDoc(tCol, {
                    image: a.target?.result,
                    order: this.state.Pics.length + 1
                });
                
                var tSnap = await getDocs(query(tCol,orderBy("order",'asc')));

                this.setState({Pics: tSnap.docs});
            }
            x.readAsDataURL(files[i]);
        }
       
    }

    async componentDidMount() {
        var tCol = collection(dbPublic,'showpictures');
        var tSnap = await getDocs(query(tCol,orderBy("order",'asc')));
        this.setState({Pics: tSnap.docs});
    }

    render() {

        return(<div style={{height: '100%', fontFamily: 'avenir'}}>
            <Toolbar />
            <section style={{marginLeft: '210px',height: '100%',display: 'flex',flexDirection:'column', justifyContent: 'flex-start', alignItems: 'flex-start'}}>
                <div style={{width: '100%', fontFamily: 'avenirb', fontSize: '30pt'}}>
                    SHOWS & RESULTS
                </div>
                <div>
                    <div style={{fontFamily: 'avenirb'}}></div>
                    Add or edit pictures for SHOWS & RESULTS section of the website.<br/><br/>
                </div>
                <div className="PictureBoxDD" style={{position: 'relative',width: '95%', border: '3px dashed rgba(0,0,0,.3)', backgroundColor: 'rgba(200,0,0,.3)'}} onDrop={(e)=>{
                        e.preventDefault();
                        
                        this.downloadPics(e.dataTransfer.files);
                    }} onDragOver={(e)=>{e.preventDefault();}} onDragEnter={(e)=>{e.preventDefault();}}>
                    <div style={{width: '100%', height: '100%', padding: 30, display: 'flex'}}>Drag and drop pictures here or&nbsp;<br/><div style={{position: 'relative', textDecoration: 'underline', cursor: 'pointer'}}>click here <input type="file" multiple name="file" id="file" style={{position: 'absolute', cursor: 'pointer', left: 0, top: 0, opacity: 0,  }} onChange={(e)=>{
                        
                        this.downloadPics(e.target.files!); 
                    }}/></div>&nbsp;to select images.
                    
                    </div>
                </div>
                <div style={{width: '100%',display: 'grid', gridTemplateColumns: 'repeat(auto-fill,minmax(200px,1fr)',gap: 20, padding: 20,}}>
                    {this.state.Pics.map((p0:any,i:number)=>{
                        var p = p0.data();
                        return (<div style={{position: 'relative'}}>
                            <img src={p.image} style={{width: '200px', height: '140px', borderRadius: '10px', cursor: 'pointer', objectFit: 'cover', border: '1px dotted rgba(0,0,0,.3)'}} />
                            <br/>
                            <input type="text" style={{width: 190, height: 30, padding: 5, borderRadius: 10, border: '1px solid rgba(0,0,0,.3)'}} defaultValue={p.description} onBlur={async (e)=>{
                                p.description = e.target.value;
                                await updateDoc(p0.ref,{description: e.target.value});
                            }}/>
                            <div style={{position: 'absolute', top: -5, right: -5, height: 40, width: 40, backgroundColor: 'black', color: 'white', borderRadius: 20, textAlign: 'center', fontSize: '18pt', fontFamily: 'avenirb', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer'}} onClick={async ()=>{
                                await deleteDoc(p0.ref);
                                var tCol = collection(dbPublic,'showpictures');
                                var tSnap = await getDocs(query(tCol,orderBy("order",'asc')));
                                this.setState({Pics: tSnap.docs});
                            }}><CgCloseO /></div></div>
                        )
                    })}
                    
                </div>
            </section>
        </div>)
    }
}

export default Shows;